<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68 fail-icon" />
      <h2>{{ $t('message["428"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="typeError.error===104 ">
          {{ failTips[0] }}<br> {{ failTips[1] }}<br>{{ failTips[2] }}。
        </template>
        <template v-else>
          <template v-if="typeError.payload">
            <template v-if="typeError.payload.usertype===2">
              {{ failTelTip[0] }} {{ value }}  {{ failTelTip[1] }}<br>{{ failTelTip[2] }}{{ typeName }}。
            </template>
            <template v-else-if="typeError.payload.usertype===3">
              {{ failEmailTip[0] }} {{ value }}   {{ failEmailTip[1] }}<br>{{ failEmailTip[2] }}{{ typeName }}。
            </template>
            <template v-else-if="typeError.payload.usertype===1">
              {{ failAccounTip[0] }}{{ value }}  {{ failAccounTip[1] }}<br>{{ typeName }}。
            </template>
          </template>
        </template>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    typeError: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    failAccounTip () {
      return this.$t('message["1054"]').split('|')
    },
    failTelTip () {
      return this.$t('message["1057"]').split('|')
    },
    failTips () {
      return this.$t('message["1061"]').split('|')
    },
    failEmailTip () {
      return this.$t('message["1063"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip-box .icon-tixing {
  color: #f57676 !important;
}
</style>
